import { Injectable } from '@angular/core';
import { Tag } from '../models/tag';

export interface TagDescription {
  description: string;
  class: string;
}

@Injectable({
  providedIn: 'root'
})
export class TagManagementService {

  private readonly TAG_DESCRIPTIONS: { [key: string]: TagDescription } = {
    'Red': {
      description: 'Falha Grave',
      class: 'red-background'
    },
    'Orange': {
      description: 'Alerta (Erro cometido as vezes)',
      class: 'orange-background'
    },
    'Yellow': {
      description: 'Atenção (Corrigir de forma educativa)',
      class: 'yellow-background'
    },
    'Green': {
      description: 'Dever cumprido!',
      class: 'green-background'
    },
    'Blue': {
      description: 'Acima da média',
      class: 'blue-background'
    },
    'Purple': {
      description: 'Ótimo, Parábens, Excelente!',
      class: 'purple-background'
    },
    'Gray': {
      description: 'Sem avaliação',
      class: 'gray-background'
    },
    'Green-Light': {
      description: 'Dever cumprido hoje',
      class: 'green-light-background'
    }
  };

  /**
   * Processa uma lista de tags e adiciona descrições e classes
   */
  processTags(tags: Tag[]): Tag[] {
    return tags.map(tag => {
      const tagInfo = this.TAG_DESCRIPTIONS[tag.name];
      if (tagInfo) {
        return {
          ...tag,
          description: tagInfo.description,
          class: tagInfo.class
        };
      }
      return tag;
    });
  }

  /**
   * Filtra tags excluindo uma específica
   */
  filterTags(tags: Tag[], excludeName: string = 'Gray'): Tag[] {
    return tags.filter(tag => tag.name !== excludeName);
  }

  /**
   * Obtém a descrição de uma tag pelo nome
   */
  getTagDescription(tagName: string): string {
    return this.TAG_DESCRIPTIONS[tagName]?.description || '';
  }

  /**
   * Obtém a classe CSS de uma tag pelo nome
   */
  getTagClass(tagName: string): string {
    return this.TAG_DESCRIPTIONS[tagName]?.class || '';
  }

  /**
   * Obtém todas as descrições de tags disponíveis
   */
  getAllTagDescriptions(): { [key: string]: TagDescription } {
    return { ...this.TAG_DESCRIPTIONS };
  }

  /**
   * Verifica se uma tag existe
   */
  isValidTag(tagName: string): boolean {
    return tagName in this.TAG_DESCRIPTIONS;
  }

  /**
   * Obtém as opções de avaliação formatadas
   */
  getEvaluationOptions() {
    return [
      { index: "1", color: "red", description: "Falha Grave" },
      { index: "2", color: "orange", description: "Alerta (Erro cometido as vezes)" },
      { index: "3", color: "yellow", description: "Atenção (Corrigir de forma educativa)" },
      { index: "4", color: "green", description: "Dever cumprido!" },
      { index: "5", color: "blue", description: "Acima da média" },
      { index: "6", color: "purple", description: "Ótimo, Parábens, Excelente!" },
    ];
  }
}
